const passwordFactory = {
  toAPI: data =>
    data && {
      current_password: data.currentPassword,
      new_password: data.newPassword
    }
}

export default passwordFactory
